<template>
	<v-card>
		<div id="lineProfileView" tile class="pa-0 chart-board" ref="lineProfileView"></div>
	</v-card>
</template>

<script>
import "./style.css";
import { register, unregister } from "@/utils/chartViewUpdaters";
export default {
	name: "LineProfileViewDialog",
	props: {
		id: String,
	},

	mounted() {
		this.updateBound = this.update.bind(this);
		register(this.updateBound);

		this.$nextTick(() => {
			this.update();
		});
	},
	beforeUnmount() {
		unregister(this.updateBound);
	},
	data: () => ({
		updateBound: null,
	}),
	methods: {
		update() {
			const canvas =
				window["viewer"] &&
				window["viewer"].getCanvasForView("lineProfileView");
			const element = this.$refs.lineProfileView;
			if (canvas && element) {
				for (const node of element.children) {
					element.removeChild(node);
				}
				element.appendChild(canvas);
				canvas.height = element.getBoundingClientRect().height;
				canvas.width = element.getBoundingClientRect().width;
				window["viewer"].resize2dView(
					{ width: canvas.width, height: canvas.height },
					"lineProfileView",
				);
			}
		},
	},
};
</script>

<style scoped>
.v-card {
	display: flex;
	flex-direction: column;
}

.chart-board {
	flex: 1;
	min-height: 0;
}
</style>